<template>
  <pre>{{ text }}</pre>
</template>

<script>
import taskpaper from '../utils/taskpaper';

export default {
  name: 'TaskItem',
  props: {
    name: String,
    options: Object,
  },
  computed: {
    text() {
      const t = new taskpaper.Task(this.name, this.options);
      return t.serialize();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
